import { Card, CardContent, Typography, Divider, Box } from "@mui/material";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";

interface Order {
  Tender: Tender;
}
interface Tender {
  id: string;
  title: string;
  value: number;
  endDate: string;
  deliverDate: string;
  type: string;
}
function TenderCard({ order }: { order: Order }) {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  return (
    <Card
      sx={{
        height: "100%",
        borderRadius: 3,
        boxShadow: "none",
        transition: "all 0.3s ease",
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            mb: 2,
            color: "#1a1a1a",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          📄 {t("tenders.details")}
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">
              {t("tenders.name")}:
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              {order.Tender?.title}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">
              {t("tender.value")}:
            </Typography>
            <Typography variant="body2" fontWeight={600} color="primary">
              {order.Tender?.value} {t("currency")}
            </Typography>
          </Box>

          {/* <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">
              {t("tenders.endDate")}:
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              {new Date(order.Tender?.endDate).toLocaleDateString()}
            </Typography>
          </Box> */}
        </Box>
      </CardContent>
    </Card>
  );
}

export default TenderCard;
